import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  Paper,
  Typography,
} from "@material-ui/core";

import {
  Warning as WarningIcon,
} from "@material-ui/icons";

const CustomerNotesReviewDialog = ({
  open,
  onClose,
  onConfirm,
  notes,
  bookingInstructions,
}) => {

  const hasNotes =
    notes !== undefined &&
    notes !== null &&
    notes.trim() !== '';

  const hasBookingInstructions =
    bookingInstructions !== undefined &&
    bookingInstructions !== null &&
    bookingInstructions.trim() !== '';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      aria-labelledby="customer-notes-review-dialog-title"
    >
      <DialogTitle id="customer-notes-review-dialog-title">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <WarningIcon style={{ color: '#FFCA06' }} />

          <span>
            Customer Notes - Please Review
          </span>
        </div>
      </DialogTitle>

      <DialogContent dividers>
      <Typography style={{ color: '#666' }}>
        Please review the customer notes and booking instructions before generating this estimate, including any{' '}
        <span style={{ color: '#f44336', fontWeight: 600 }}>
          pricing changes, charge type (TAG or HOURLY), minimum charges, and other estimating requirements.
        </span>
      </Typography>

        {hasNotes && (
          <Paper
            elevation={0}
            style={{
              border: '1px solid rgba(0,0,0,0.15)',
              borderLeft: '5px solid #FFCA06',
              padding: 16,
              marginBottom: 20,
            }}
          >
            <Typography
              variant="subtitle1"
              style={{
                fontWeight: 600,
                marginBottom: 8,
              }}
            >
              Customer Notes
            </Typography>

            <Divider style={{ marginBottom: 12 }} />

            <Typography
              variant="body1"
              style={{
                whiteSpace: 'pre-wrap',
              }}
            >
              {notes}
            </Typography>
          </Paper>
        )}

        {hasBookingInstructions && (
          <Paper
            elevation={0}
            style={{
              border: '1px solid rgba(0,0,0,0.15)',
              borderLeft: '5px solid #3f7fbf',
              padding: 16,
            }}
          >
            <Typography
              variant="subtitle1"
              style={{
                fontWeight: 600,
                marginBottom: 8,
              }}
            >
              Booking Instructions
            </Typography>

            <Divider style={{ marginBottom: 12 }} />

            <Typography
              variant="body1"
              style={{
                whiteSpace: 'pre-wrap',
              }}
            >
              {bookingInstructions}
            </Typography>
          </Paper>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>

        <Button
          onClick={onConfirm}
        >
          Reviewed - Generate Estimate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomerNotesReviewDialog;
